import { rutSinDV, soloDV } from "@shared/utils/rutParser.utils";
import { IFuncionalidades, ITerminologia, IUsuario } from "./usuario.interface";
import Perfiles from "@shared/enums/perfiles.enum";
import Roles from "@shared/enums/roles.enum";


export class Usuario implements IUsuario {
    id_sesion: string;
    rut_usuario: string;
    nombres: string;
    ape_paterno: string;
    ape_materno: string;
    mail_usuario: string;
    token: string;
    creacion: string;
    expiracion: string;
    aplicacion: string;
    perfiles: string;
    roles: string;
    cobertura: any;
    token_cu: string;
    permisos: { Funcionalidades: IFuncionalidades[]; };
    terminologia: ITerminologia;
    rolSeleccionado: Roles | null;

    getRutSinDV() {
        return rutSinDV(this.rut_usuario);
    }

    getSoloDV() {
        return soloDV(this.rut_usuario);
    }

    getNombreCompleto() {
        return `${this.nombres} ${this.ape_paterno} ${this.ape_materno}`;
    }
}